export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';

export const showModal = (modal?: string) => ({
  type: SHOW_MODAL,
  modal,
});

const hideModal = () => ({ type: HIDE_MODAL });

export default {
  showModal,
  hideModal,
};
